import { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Checkbox from "@shared/v2/Checkbox";

const FeatureRow = ({ accountId, feature }) => {
  const checkboxTitle = feature.toggle.branded ? "Brand Feature" : "";

  const [checked, setChecked] = useState(feature.toggle.enabled);

  const [toggleId, setToggleId] = useState(feature.toggle.id)

  const createFeatureToggle = (value) => {
    const p = { feature_id: feature.id, enabled: value }

    axios.post(`/support/accounts/${accountId}/feature_toggles`, p)
      .then((r) => {
        const { id, enabled } = r.data;

        setToggleId(id);

        setChecked(enabled);
      })
  }

  const updateFeatureToggle = (value) => {
    const p = { enabled: value }

    axios.patch(`/support/accounts/${accountId}/feature_toggles/${toggleId}`, p)
      .then((r) => { setChecked(r.data.enabled) })
  }

  const createOrUpdateFeatureToggle = (e) => {
    const newValue = e.target.checked;

    if (toggleId) {
      updateFeatureToggle(newValue)
    } else {
      createFeatureToggle(newValue);
    }
  }

  return (
    <tr>
      <td>{toggleId}</td>
      <td>{feature.name}</td>
      <td>{feature.desc}</td>
      <td>{feature.category}</td>
      <td>
        <Checkbox
          checked={checked}
          onChange={createOrUpdateFeatureToggle}
          disabled={feature.toggle.branded}
          title={checkboxTitle}
        />
      </td>
    </tr>
  )
}

FeatureRow.propTypes = {
  accountId: PropTypes.number.isRequired,
  feature: PropTypes.shape().isRequired
}


const SupportAccountFeatures = ({ accountId, features }) =>
  <table className="table table-striped table-hover">
    <thead>
      <tr>
        <th>Feature Toggle ID</th>
        <th>Feature</th>
        <th>Description</th>
        <th>Category</th>
        <th>Enabled?</th>
      </tr>
    </thead>
    <tbody>
      {
        features.map((feature) => (
          <FeatureRow
            key={feature.id}
            accountId={accountId}
            feature={feature}
          />
        ))
      }
    </tbody>
  </table>

SupportAccountFeatures.propTypes = {
  accountId: PropTypes.number.isRequired,
  features: PropTypes.arrayOf(PropTypes.shape()).isRequired
}

export default SupportAccountFeatures;
